module.exports = __webpack_public_path__ + "img/toUp.66c8895c.png";